module.exports = __webpack_public_path__ + "img/logo-visa.e8609d19.svg";